import { render, staticRenderFns } from "./NieuwsmakerModal.vue?vue&type=template&id=2a88f82c"
import script from "./NieuwsmakerModal.vue?vue&type=script&lang=js"
export * from "./NieuwsmakerModal.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/forge/cmgames.septemberdev.nl/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2a88f82c')) {
      api.createRecord('2a88f82c', component.options)
    } else {
      api.reload('2a88f82c', component.options)
    }
    module.hot.accept("./NieuwsmakerModal.vue?vue&type=template&id=2a88f82c", function () {
      api.rerender('2a88f82c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/student/vue/nieuwsmaker/components/NieuwsmakerModal.vue"
export default component.exports